import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkflowDataService } from '../data-table/workflow-data.service';
import { ContentAdminTreeItem, ContentItem, ContentTreeItem } from '../models/contents.model';

export type UrlKey = {
  url: string;
  key: string;
};

@Injectable({ providedIn: 'root' })
export class ContentsService extends WorkflowDataService<ContentItem> {
  protected override get apiEndpoint(): string {
    return '/content';
  }

  getTree(): Observable<ContentTreeItem[]> {
    return this.http.get<ContentTreeItem[]>(`${this.baseUrl + this.apiEndpoint}/tree`);
  }

  getSignedUploadUrl(filename: string, contentType: string): Observable<UrlKey> {
    return this.http.get<UrlKey>(`${this.baseUrl + this.apiEndpoint}/upload-url`, { params: { filename, contentType } });
  }

  getSignedUrl(fileKey: string): Observable<string> {
    return this.http.get<string>(`${this.baseUrl + this.apiEndpoint}/signed-url`, { params: { fileKey } });
  }

  getForView(id: string): Observable<ContentItem> {
    return this.http.get<ContentItem>(`${this.baseUrl + this.apiEndpoint}/${id}/view`);
  }

  getTreeOfParent(id: string): Observable<ContentTreeItem[]> {
    return this.http.get<ContentTreeItem[]>(`${this.baseUrl + this.apiEndpoint}/${id}/tree`);
  }

  getTreeForManagement(): Observable<ContentAdminTreeItem[]> {
    return this.http.get<ContentAdminTreeItem[]>(`${this.baseUrl + this.apiEndpoint}/tree?showFull`);
  }

  getChildren(id: string): Observable<ContentItem[]> {
    return this.http.get<ContentItem[]>(`${this.baseUrl + this.apiEndpoint}/${id}/children`);
  }

  sort(id: string, sortedIds: string[]): Observable<ContentItem> {
    return this.http.put<ContentItem>(`${this.baseUrl + this.apiEndpoint}/${id}/sort`, sortedIds);
  }

  hide(id: string): Observable<ContentItem> {
    return this.http.patch<ContentItem>(`${this.baseUrl + this.apiEndpoint}/${id}/hide`, null);
  }

  show(id: string): Observable<ContentItem> {
    return this.http.patch<ContentItem>(`${this.baseUrl + this.apiEndpoint}/${id}/show`, null);
  }
}
